module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "toc",
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    staticClass: "toc"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_df_r1.htm"
    }
  }, [_c('em', [_vm._v("Dear Friends")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_ing_r1.htm"
    }
  }, [_c('em', [_vm._v("Ingredients")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_p01_r1.htm"
    }
  }, [_c('em', [_c('span', {
    staticClass: "big"
  }, [_vm._v("Appetizers")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    staticStyle: {
      "margin-top": "-1em"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/9781449400217_toc-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c01_r1.htm"
    }
  }, [_c('em', [_vm._v("Kelsey’s Cranberry Salsa")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c02_r1.htm"
    }
  }, [_c('em', [_vm._v("Black Bean and Corn Salsa")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c03_r1.htm"
    }
  }, [_c('em', [_vm._v("Cheryl’s Cucumber-Tomato Salsa")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c04_r1.htm"
    }
  }, [_c('em', [_vm._v("A Little Gift of Herbs")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c05_r1.htm"
    }
  }, [_c('em', [_vm._v("Hummus Spread with Pita Bread")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c06_r1.htm"
    }
  }, [_c('em', [_vm._v("Herb Cheese Spread")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c07_r1.htm"
    }
  }, [_c('em', [_vm._v("Jody’s Feta Cheese Spread")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c08_r1.htm"
    }
  }, [_c('em', [_vm._v("Mexicorn Dip")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c09_r1.htm"
    }
  }, [_c('em', [_vm._v("Peppercorn Dip")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c10_r1.htm"
    }
  }, [_c('em', [_vm._v("Kelly’s Tutti Fruity Dip")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c11_r1.htm"
    }
  }, [_c('em', [_vm._v("Joy’s Glazed Pecans")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c12_r1.htm"
    }
  }, [_c('em', [_vm._v("Kate and Maureen’s Pinwheel Re-Treats")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c13_r1.htm"
    }
  }, [_c('em', [_vm._v("Chick-a-Dillies")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c14_r1.htm"
    }
  }, [_c('em', [_vm._v("Auntie’s Pretzels")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c15_r1.htm"
    }
  }, [_c('em', [_vm._v("DooDah Doodles")]), _c('br'), _c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c16_r1.htm"
    }
  }, [_c('em', [_vm._v("Table Topics")]), _c('br'), _c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    staticStyle: {
      "margin-top": "-1em"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_p02_r1.htm"
    }
  }, [_c('em', [_c('span', {
    staticClass: "big"
  }, [_vm._v("Main")])])]), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/9781449400217_toc-2.jpg"
    }
  }), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_p02_r1.htm"
    }
  }, [_c('span', {
    staticClass: "big"
  }, [_c('em', [_vm._v("Dishes")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c17_r1.htm"
    }
  }, [_c('em', [_vm._v("Grilled Cheese Dippers")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c18_r1.htm"
    }
  }, [_c('em', [_vm._v("Southwestern Tomato-Cheese Soup")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c19_r1.htm"
    }
  }, [_c('em', [_vm._v("Pretzel Dogs")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c20_r1.htm"
    }
  }, [_c('em', [_vm._v("Baked Mostaccioli")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c21_r1.htm"
    }
  }, [_c('em', [_vm._v("Grilled Pepper Steaks")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c22_r1.htm"
    }
  }, [_c('em', [_vm._v("Chicken with Pasta")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c23_r1.htm"
    }
  }, [_c('em', [_vm._v("Crispy Baked Tilapia")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c24_r1.htm"
    }
  }, [_c('em', [_vm._v("Hawaiian Chicken")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c25_r1.htm"
    }
  }, [_c('em', [_vm._v("Brooke’s Baja Tacos")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c26_r1.htm"
    }
  }, [_c('em', [_vm._v("Slow Cooker Pork Chops")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c27_r1.htm"
    }
  }, [_c('em', [_vm._v("Slow Cooker Ribs")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c28_r1.htm"
    }
  }, [_c('em', [_vm._v("White Bean Chili")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c29_r1.htm"
    }
  }, [_c('em', [_vm._v("Baked Orange Roughy")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c30_r1.htm"
    }
  }, [_c('em', [_vm._v("Southwestern Egg Casserole")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c31_r1.htm"
    }
  }, [_c('em', [_vm._v("Wisdom Roast")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c32_r1.htm"
    }
  }, [_c('em', [_vm._v("The Sisters’ Meat Loaf")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c33_r1.htm"
    }
  }, [_c('em', [_vm._v("Herzeghs’ Swiss Chicken")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c34_r1.htm"
    }
  }, [_c('em', [_vm._v("Grilled Chicken Breasts")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c35_r1.htm"
    }
  }, [_c('em', [_vm._v("Dee’s Sweet and Savory Wraps")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c36_r1.htm"
    }
  }, [_c('em', [_vm._v("RO-TEL Chicken")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c37_r1.htm"
    }
  }, [_c('em', [_vm._v("The Baker Girls’ Pizza Turnovers")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c38_r1.htm"
    }
  }, [_c('em', [_vm._v("Pork Tenderloin with Ginger Glaze")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c39_r1.htm"
    }
  }, [_c('em', [_vm._v("Kinderhook Quiche")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c40_r1.htm"
    }
  }, [_c('em', [_vm._v("Zippy Omelets")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c41_r1.htm"
    }
  }, [_c('em', [_vm._v("Spinach & Chicken Pasta Bake")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c42_r1.htm"
    }
  }, [_c('em', [_vm._v("Party Pizza Dough")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c43_r1.htm"
    }
  }, [_c('em', [_vm._v("Personal Pizzas on the Grill")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c44_r1.htm"
    }
  }, [_c('em', [_vm._v("Chicken-Chile Quiche")]), _c('br'), _c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c45_r1.htm"
    }
  }, [_c('em', [_vm._v("Invisible Guests")]), _c('br'), _c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_p03_r1.htm"
    }
  }, [_c('em', [_c('span', {
    staticClass: "big"
  }, [_vm._v("Side Dishes")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center10"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_p03_r1.htm"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/9781449400217_toc-3.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bigtoc"
  }, [_c('em', [_vm._v("and")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center15"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_p03_r1.htm"
    }
  }, [_c('span', {
    staticClass: "big"
  }, [_c('em', [_vm._v("Salads")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c46_r1.htm"
    }
  }, [_c('em', [_vm._v("Sweet Green Beans")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c47_r1.htm"
    }
  }, [_c('em', [_vm._v("Sweet Ginger Carrots")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c48_r1.htm"
    }
  }, [_c('em', [_vm._v("Blake’s Cream Cheese Corn")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c49_r1.htm"
    }
  }, [_c('em', [_vm._v("Poppy Seed Summer Slaw")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c50_r1.htm"
    }
  }, [_c('em', [_vm._v("Christine’s Tomato Tart")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c51_r1.htm"
    }
  }, [_c('em', [_vm._v("Macadamia Wild Rice Pilaf")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c52_r1.htm"
    }
  }, [_c('em', [_vm._v("Herbed Potato Gratin")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c53_r1.htm"
    }
  }, [_c('em', [_vm._v("Salad Caprice")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c54_r1.htm"
    }
  }, [_c('em', [_vm._v("Broccoli Salad")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c55_r1.htm"
    }
  }, [_c('em', [_vm._v("Grape Salad")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c56_r1.htm"
    }
  }, [_c('em', [_vm._v("Jayne’s Strawberry-Mandarin Tossed Salad")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c57_r1.htm"
    }
  }, [_c('em', [_vm._v("Mrs. Chiles’s Glazed Fruit Salad")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c58_r1.htm"
    }
  }, [_c('em', [_vm._v("Penne Pasta Salad")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c59_r1.htm"
    }
  }, [_c('em', [_vm._v("Ellen’s Holiday Berry Salad")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c60_r1.htm"
    }
  }, [_c('em', [_vm._v("Mac and Cheese")]), _c('br'), _c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c61_r1.htm"
    }
  }, [_c('em', [_vm._v("I’ll Have What She’s Having")]), _c('br'), _c('br'), _c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "center111",
    staticStyle: {
      "margin-top": "-1em"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_p04_r1.htm"
    }
  }, [_c('em', [_c('span', {
    staticClass: "big"
  }, [_vm._v("Breads,")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center1111"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_p04_r1.htm"
    }
  }, [_c('em', [_c('span', {
    staticClass: "big"
  }, [_vm._v("Muffins &")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center11111"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_p04_r1.htm"
    }
  }, [_c('em', [_c('span', {
    staticClass: "big"
  }, [_vm._v("Spreads")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center20"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/9781449400217_toc-4.jpg"
    }
  }), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c62_r1.htm"
    }
  }, [_c('em', [_vm._v("The Creeds’ Sleepover Breakfast Bread")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c63_r1.htm"
    }
  }, [_c('em', [_vm._v("Beehive Butter")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c64_r1.htm"
    }
  }, [_c('em', [_vm._v("Honey Whole Wheat Bread")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c65_r1.htm"
    }
  }, [_c('em', [_vm._v("Peaches and Cream Muffins")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c66_r1.htm"
    }
  }, [_c('em', [_vm._v("Monkey Bread")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c67_r1.htm"
    }
  }, [_c('em', [_vm._v("Mocha Muffins")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c68_r1.htm"
    }
  }, [_c('em', [_vm._v("Focaccia Bread")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c69_r1.htm"
    }
  }, [_c('em', [_vm._v("Sour Cream Muffins")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c70_r1.htm"
    }
  }, [_c('em', [_vm._v("Carol’s Tasty Italian Biscuit Bites")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c71_r1.htm"
    }
  }, [_c('em', [_vm._v("Beer Batter Bread")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c72_r1.htm"
    }
  }, [_c('em', [_vm._v("Heirloom Rolls")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c73_r1.htm"
    }
  }, [_c('em', [_vm._v("Cinnamon Rolls")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c74_r1.htm"
    }
  }, [_c('em', [_vm._v("Banana–Chocolate Chip Bread")]), _c('br'), _c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c75_r1.htm"
    }
  }, [_c('em', [_vm._v("Loaves and Fishes")]), _c('br'), _c('br'), _c('br'), _c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    staticStyle: {
      "margin-top": "-1em"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_p05_r1.htm"
    }
  }, [_c('em', [_c('span', {
    staticClass: "big"
  }, [_vm._v("Desserts")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center20"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/9781449400217_toc-5.jpg"
    }
  }), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c76_r1.htm"
    }
  }, [_c('em', [_vm._v("Fruit Pizza")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c77_r1.htm"
    }
  }, [_c('em', [_vm._v("PB and J Bars")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c78_r1.htm"
    }
  }, [_c('em', [_vm._v("Lisa’s Bliss Bars")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c79_r1.htm"
    }
  }, [_c('em', [_vm._v("Brooke’s Blonde Rockies")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c80_r1.htm"
    }
  }, [_c('em', [_vm._v("Roxie’s Orange Sugar Cookies")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c81_r1.htm"
    }
  }, [_c('em', [_vm._v("Melt-in-Your-Mouth Cookies")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c82_r1.htm"
    }
  }, [_c('em', [_vm._v("Caramel Oatmeal Bars")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c83_r1.htm"
    }
  }, [_c('em', [_vm._v("Lunch Box Brownies")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c84_r1.htm"
    }
  }, [_c('em', [_vm._v("Peanut Butter Blondies")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c85_r1.htm"
    }
  }, [_c('em', [_vm._v("Not Fried Ice Cream")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c86_r1.htm"
    }
  }, [_c('em', [_vm._v("Chocolate Cheesecake")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c87_r1.htm"
    }
  }, [_c('em', [_vm._v("Pumpkin Cheesecake")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c88_r1.htm"
    }
  }, [_c('em', [_vm._v("Earthquake Cake")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c89_r1.htm"
    }
  }, [_c('em', [_vm._v("Apple Squares")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c90_r1.htm"
    }
  }, [_c('em', [_vm._v("Cranberry-Orange Coffeecake")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c91_r1.htm"
    }
  }, [_c('em', [_vm._v("Pecan Fudge Sheet Cake with Fudge Frosting")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c92_r1.htm"
    }
  }, [_c('em', [_vm._v("Fast Fondue")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c93_r1.htm"
    }
  }, [_c('em', [_vm._v("Jan’s Just “Dew” It Apple Dessert")]), _c('br'), _c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c94_r1.htm"
    }
  }, [_c('em', [_vm._v("Solitary Refinement")])]), _c('br'), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center11",
    staticStyle: {
      "margin-top": "-1em"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_p06_r1.htm"
    }
  }, [_c('em', [_c('span', {
    staticClass: "big"
  }, [_vm._v("This")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center11111"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_p06_r1.htm"
    }
  }, [_c('em', [_c('span', {
    staticClass: "bigcop1"
  }, [_vm._v("and")]), _vm._v(" "), _c('span', {
    staticClass: "big"
  }, [_vm._v("That")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center20"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/9781449400217_toc-6.jpg"
    }
  }), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c95_r1.htm"
    }
  }, [_c('em', [_vm._v("Maurice’s Holiday Tea")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c96_r1.htm"
    }
  }, [_c('em', [_vm._v("House of Grace Tea")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c97_r1.htm"
    }
  }, [_c('em', [_vm._v("Christine’s Marinade")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c98_r1.htm"
    }
  }, [_c('em', [_vm._v("Lance’s Pork and Poultry Marinade")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c99_r1.htm"
    }
  }, [_c('em', [_vm._v("Bread Crumb Blend")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c100_r1.htm"
    }
  }, [_c('em', [_vm._v("Toasting Nuts")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c101_r1.htm"
    }
  }, [_c('em', [_vm._v("We’re Talking Tools")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c102_r1.htm"
    }
  }, [_c('em', [_vm._v("A Well-Equipped Kitchen")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400217_epub_c103_r1.htm"
    }
  }, [_c('em', [_vm._v("Timeless Tips")]), _c('br'), _c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/9781449400217_x-1.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46b77cc2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781449400217_epub_toc_r1.vue
// module id = 75
// module chunks = 0